const generateCountdown = (target) => {
    const now = Date.now();
    const timeLeftInSeconds = Math.floor((target.getTime() - now) / 1000);
    const daysLeft = Math.floor(timeLeftInSeconds / (24 * 60 * 60));
    const timeLeftInHours = timeLeftInSeconds % (24 * 60 * 60);
    const hoursLeft = Math.floor(timeLeftInHours / (60 * 60));
    const timeLeftInMinutes = timeLeftInHours % (60 * 60);
    const minutesLeft = Math.floor(timeLeftInMinutes / 60);
    const secondsLeft = timeLeftInMinutes % 60;

    return {
        days: daysLeft,
        hours: hoursLeft,
        minutes: minutesLeft,
        seconds: secondsLeft,
    };
};

const generateCountdownText = ({ days, hours, minutes, seconds }) => {
    if (!days && !hours && !minutes && !seconds) return '';

    return `<strong>${days < 10 ? '0' + days : days}</strong>d <strong>${
        hours < 10 ? '0' + hours : hours
    }</strong>h <strong>${
        minutes < 10 ? '0' + minutes : minutes
    }</strong>m <strong>${seconds < 10 ? '0' + seconds : seconds}</strong>s`;
};

export default { generateCountdown, generateCountdownText };
